<template>
<div>
    <img :src="imgUrl" />
    <p>您已经对该样品操作成功！</p>
</div>
    
</template>
<script>
export default {
    name:'allotSuccess',
    data(){
        return {
            currentRate:0,
            rate:100,
            imgUrl: process.env.BASE_URL + "img/success.jpg"
        }
    },
    mounted(){
        this.currentRate = 100;
    }
    
}
</script>
<style scoped>
div{
    padding-top:20%; 
    text-align: center;
}
p{
    text-align: center;
    color:#222;
}
img{
    width:5rem;
}


</style>